<mat-form-field>
  <mat-select placeholder="Select..." (valueChange)="change()" [(ngModel)]="value" multiple="true" name="item">
    <mat-option *ngFor="let item of question.configuration.options" [value]="item.value">
      {{ item.key }}
    </mat-option>
  </mat-select>
</mat-form-field>
